import React from 'react';
import { Avatar } from 'antd';
import { t } from 'i18next';
import { InfoCardContainer } from '@/comp/Forms/SiteSurveyForm/CustomerInformationStep/InfoCard.styles';

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  onEdit: () => void;
  content: React.ReactNode;
  hasData: boolean;
}

const InfoCard: React.FC<InfoCardProps> = ({ icon, title, onEdit, content, hasData }) => {
  return (
    <InfoCardContainer className="info-card-wrapper">
      <div className="info-card">
        <div className="info-card-header">
          <div className="info-card-title-wrapper">
            <Avatar className="icon-avatar" icon={icon} />
            <span className="info-card-title">{t(title)}</span>
          </div>
          <span className="edit-button" onClick={onEdit}>
            {t('edit')}
          </span>
        </div>
        <div className="info-card-content">{hasData && content}</div>
      </div>
    </InfoCardContainer>
  );
};

export default InfoCard;
